import React, { useState, useContext } from 'react'
import { UserContext } from 'stores/UserStore'
import managementTransport from 'api/managementTransport'
import { descompressResponse } from 'utils/decompress'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { isNull, isUndefined } from 'lodash'

export const TransportContext = React.createContext({})

export const TransportProvider = ({ children }) => {
    const [openAttachCTe, setOpenAttachCTe] = useState(false)
    const [openDeleteAttach, setOpenDeleteAttach] = useState(false)
    const [openChangeStatus, setOpenChangeStatus] = useState(false)
    const [openAttachEvidence, setOpenAttachEvidence] = useState(false)
    const [openReportDaily, setOpenReportDaily] = useState(false)

    const [transportSearch, setTransportSearch] = useState([])
    const [resultInformation, setResultInformation] = useState([])
    const [idTransport, setIdTransport] = useState([])
    const [loading, setLoading] = useState(false)
    // search code
    const [solicitacao, setSolicitacao] = useState('')
    const [mapa, setMapa] = useState('')
    const [status, setStatus] = useState('')
    const [origem, setOrigem] = useState('')
    const [destino, setDestino] = useState('')
    const [transportadora, setTransportadora] = useState('')

    const { currentUser, idToken } = useContext(UserContext)
    const { t } = useTranslation()
    // BUSCA DA PAGINA PRINCIPAL
    const getSearchTransport = async () => {
        setLoading(true)
        const payload = {
            name: !currentUser.roles.VSM_SUPPLIER.VSM_SUPPLIER_TRANSPORT_ADM ? Object.keys(currentUser.roles.SUPPLIERS).find((item) => item !== 'id') : ''
        }

        await managementTransport.getTransport(idToken, payload).then(data => {
            data = data.body ? data.body : data
            const descompressData = descompressResponse(data)
            setTransportSearch(descompressData)
            if (descompressData.length === 0) {
                toast.warn(t('transport.noData'))
            }
            setLoading(false)
        }).catch(error => {
            setLoading(false)
            toast.error(t('transport.error' + error))
        })
    }

    // BUSCA DOS DADOS DO TRANSPORTE ESPECÍFICO
    const getInfoTransport = async (payload) => {
        setLoading(true)
        await managementTransport.getInfoTransport(idToken, payload).then(data => {
            data = data.body ? data.body : data
            const descompressData = descompressResponse(data)
            window.localStorage.setItem('id', descompressData.id)
            setIdTransport(descompressData.id)
            setResultInformation(descompressData)
            setLoading(false)
        }).catch(error => {
            console.debug(error)
            setLoading(false)
            toast.error(t('transport.error' + error))
        })
    }

    // ADICIONAR, EXCLUIR OU ABRIR ANEXOS
    const manageAttachments = async (payload, option) => {
        setLoading(true)
        await managementTransport.manageAttachments(idToken, payload, option).then(async data => {
            data = data.body ? data.body : data
            const descompressData = descompressResponse(data)

            if (option === 'insert') {
                let payload = {
                    status_from: resultInformation.status,
                    user_id: currentUser.id,
                    user_name: currentUser.name,
                    date: new Date(),
                    supplier_transport_request_id: resultInformation.id,
                    transport_id: solicitacao,
                    status_to: Number(resultInformation.status) === 7 ? 9 : Number(resultInformation.status) + 1,
                    description: `${t(`transport.${Number(resultInformation.status) + 1}`)}`,
                    shippingCompany: resultInformation.shippingCompany
                }

                await changeStatus(payload)
                window.location.reload()

            } else if (option === 'open') {
                window.open(descompressData, '_blank')
            }
            else {
                window.location.reload()
            }
        }).catch(error => {
            console.debug(error)
            toast.error(t('transport.error' + error))
        }).finally(() => {
            setLoading(false)
        })
    }

    const getAttachSGRO = async (payload) => {
        setLoading(true)
        await managementTransport.getAttachSGRO(idToken, payload).then(data => {
            data = data.body ? data.body : data
            const descompressData = descompressResponse(data)
            setLoading(false)
            window.open(descompressData, '_blank')
        }
        ).catch(error => {
            setLoading(false)
            toast.error(t('transport.error' + error))
        })
    }

    const transformFileToBase64 = (content) => {
        let binary = ''
        const bytes = new Uint8Array(content)
        const len = bytes.byteLength
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i])
        }
        const base64 = btoa(binary)
        return base64
    }

    const sendAttachment = async (fileList, option) => {
        setLoading(true)
        const payload = new Array(fileList.length)
        let completed = 0

        fileList.forEach((file, index) => {
            const reader = new FileReader()
            reader.readAsArrayBuffer(file)
            reader.onload = (e) => {
                const byteArray = (e.target).result
                const base64 = transformFileToBase64(byteArray)
                payload[index] = {
                    supplier_transport_request_id: solicitacao,
                    name: file.name,
                    file_type: option,
                    uri: `smart-mobile/solicitacao-transporte/${file.name + new Date()}`,
                    user_id: currentUser.id,
                    file: base64,
                    status: Number(resultInformation.status) + 1,
                    user_name: currentUser.name,
                    uuid: idTransport
                }
            }

            reader.onloadend = async () => {
                completed++
                if (completed === fileList.length) {
                    await manageAttachments(payload, "insert")
                }
            }
        })

        setLoading(false)
    }

    // MUDAR O STATUS DO TRANSPORTE
    const changeStatus = async (payload) => {
        setLoading(true)
        await managementTransport.changeStatus(idToken, payload).then(data => {
            setLoading(false)
            if (payload.status_to !== 0) {
                toast.success(t('transport.status.' + payload.status_to))
            } else {
                toast.success(t('transport.reverseMessage'))
            }
            setTimeout(() => {
                window.location.reload()
            }, 2000)
            return data.status
        }
        ).catch(error => {
            setLoading(false)
            toast.error(t('transport.error' + error))
        })
    }

    const validateApprove = () => {
        let problem = 0
        const keysOther = Object.keys(resultInformation.otherInformation)
        const keysTax = Object.keys(resultInformation.taxInformation)
        const keysInfo = Object.keys(resultInformation.transportInformation)
        const keysCTE = Object.keys(resultInformation.cte)

        keysOther.map((item) => (
            !isUndefined(resultInformation.otherInformation[item]) &&
                !isNull(resultInformation.otherInformation[item]) &&
                resultInformation.otherInformation[item] !== '' ? 0 : problem++
        ))

        keysTax.map((item) => (
            !isUndefined(resultInformation.taxInformation[item]) &&
                !isNull(resultInformation.taxInformation[item]) &&
                resultInformation.taxInformation[item] !== '' ? 0 : problem++
        ))

        keysInfo.map((item) => (
            !isUndefined(resultInformation.transportInformation[item]) &&
                !isNull(resultInformation.transportInformation[item]) &&
                resultInformation.transportInformation[item] !== '' ? 0 : problem++
        ))

        keysCTE.map((item) => (
            !isUndefined(resultInformation.cte[item]) &&
                !isNull(resultInformation.cte[item]) &&
                resultInformation.cte[item] !== '' ? 0 : problem++
        ))

        if (resultInformation.attachs.length === 0) {
            problem++
        }
        // toast.warn(t('transport.waitingData'))

        return problem
    }

    return <TransportContext.Provider value={{
        resultInformation, setResultInformation,
        openAttachCTe, setOpenAttachCTe,
        openDeleteAttach, setOpenDeleteAttach,
        openChangeStatus, setOpenChangeStatus,
        openAttachEvidence, setOpenAttachEvidence,
        openReportDaily, setOpenReportDaily,
        transportSearch, setTransportSearch,
        solicitacao, setSolicitacao,
        mapa, setMapa,
        status, setStatus,
        origem, setOrigem,
        destino, setDestino,
        transportadora, setTransportadora,
        getSearchTransport,
        loading, setLoading,
        idTransport, setIdTransport,
        getInfoTransport, manageAttachments, changeStatus,
        sendAttachment,
        validateApprove,
        getAttachSGRO
    }}>
        {children}
    </TransportContext.Provider>
}